import { INVITE_TEMP_DRIVER } from '@/constants/apiRoutes';
import { post } from '@/utilities/onwardClient';

export const inviteTempDriver = async (order_id, event_id, driver_type = 'FINAL_MILE') => {
    return post(INVITE_TEMP_DRIVER, {
        order_id,
        event_id,
        driver_type,
    });
};
